/* //////////////////////////////////////////////////////////////////////////
                                  J Q U E R Y
   ////////////////////////////////////////////////////////////////////////// */

jQuery(document).ready(function($) {

/* ==========================================================================
   Input Placeholder
   ========================================================================== */

$('input[placeholder]').simplePlaceholder();

/* ==========================================================================
   Slider Cycle
   ========================================================================== */

// Previous Link
//$("#slider").before('<a class="previous" title="Previous Slide">&laquo;</a>');

// Next Link
//$("#slider").after('<a class="next" title="Next Slide">&raquo;</a>');

// Cycle
//$("#slider").cycle({prev:".previous",next:".next",delay:2000,speed:2000,speedIn:0,speedOut:0,timeout:1200,cleartype:true});

}); // End jQuery
